import { useCallback } from 'react'

import { useLazyQuery } from '@apollo/client'
import {
  AuthorizationsDataInput,
  BankingValueObjectsProviderEnum,
  ReadBankingAuthorizationDocument,
} from 'generated/resources/graphql'

export const useBankingAuthorization = () => {
  const [fetchAuthorization, { loading }] = useLazyQuery(ReadBankingAuthorizationDocument)

  const getAuthorizationUrl = useCallback(
    async (
      employeeId: string,
      redirectUrl: string,
      provider: BankingValueObjectsProviderEnum,
      data?: AuthorizationsDataInput
    ) => {
      const result = await fetchAuthorization({
        variables: {
          data,
          employeeId,
          provider,
          redirectUrl,
        },
      })

      const authorization = result.data?.banking?.authorizationsConnection?.nodes[0] || undefined
      return authorization?.authorizationUrl || undefined
    },
    [fetchAuthorization]
  )

  return {
    getAuthorizationUrl,
    loading,
  }
}
